import FilterCarousel from '@components/Slider/FilterCarousel.jsx'

import disneyPrincessFiltersData from '@data/filters/disney_princess_filters.json'

let collectionFiltersFooterData = null

const CollectionFooter = ({
    handleVisualFilterClick,
    selectedVisualFilter,
    slug,
    // collectionDescription,
}) => {
    if (slug && slug === 'mickey-minnie-mouse-disney-sunshine') {
        collectionFiltersFooterData = disneyPrincessFiltersData
    }

    return (
        <div className="collection-footer-outer w-full">
            <div className="collection-footer-inner">
                {collectionFiltersFooterData ? (
                    <div className="filter-carousel">
                        <FilterCarousel
                            carouselData={collectionFiltersFooterData}
                            slug={slug}
                            handleVisualFilterClick={handleVisualFilterClick}
                            selectedVisualFilter={selectedVisualFilter}
                            fromCollectionFooter={true}
                        />
                    </div>
                ) : null}
                {/* {collectionDescription ? (
                    <div className="collection-description-outer w-full flex flex-col items-center justify-center mt-6 mb-12">
                        <p className="collection-description font-normal leading-snug text-sm text-center ">
                            {collectionDescription}
                        </p>
                    </div>
                ) : null} */}
            </div>
        </div>
    )
}

export default CollectionFooter
